import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import { AllUserGroupsScreenPath } from "./AllUserGroupsScreen.tsx";

export function useToAllUserGroups() {
  const navigate = useNavigate();

  const toAllUserGroups = useCallback(() => {
    navigate(AllUserGroupsScreenPath);
  }, [navigate]);

  return { toAllUserGroups };
}
